// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g7ImTTZWW1kd7CC9kffZ{flex-grow:1;padding:0 16px;display:flex;position:relative}.x6vn_1RBUR01unS4EmSk{flex-direction:column;flex-grow:1;justify-content:center;align-items:center;gap:32px;display:flex}.x5Wy_dP_Xog1S8KYZska{background:linear-gradient(#f6f7f8 0%,#e9ebec 100%);border-radius:8px;overflow:hidden}.x5Wy_dP_Xog1S8KYZska img{display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `g7ImTTZWW1kd7CC9kffZ`,
	"empty": `x6vn_1RBUR01unS4EmSk`,
	"emptyPreview": `x5Wy_dP_Xog1S8KYZska`
};
export default ___CSS_LOADER_EXPORT___;
